'use client'
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { itemImageType } from '@/lib/item/server'
import { useEffect, useState } from 'react'

type CarouselImageProps = {
  images: itemImageType[]
  item_id: number
  service_id: string
}

export const PcItemImageCarousel: React.FC<CarouselImageProps> = ({
  images,
}) => {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [, setCount] = useState(0)
  useEffect(() => {
    if (!api) {
      return
    }
    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap() + 1)
    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])
  return (
    <Carousel
      className="lg:w-[480px]"
      setApi={setApi}
      opts={{
        loop: true,
      }}
    >
      <CarouselContent>
        {images.map((v, index) => (
          <CarouselItem key={index}>
            <img
              src={v.image_url}
              alt={v.image_url}
              width={480}
              height={480}
              style={{
                height: '480px',
                objectFit: 'contain',
                verticalAlign: 'center',
              }}
              className="mx-auto"
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious style={{ left: 0 }} />
      <CarouselNext style={{ right: 0 }} />
      <div className="flex overflow-x-auto">
        {images.map((v, index) => (
          <img
            key={index}
            src={v.image_url}
            alt={v.image_url}
            width={70}
            height={70}
            onClick={() => {
              api?.scrollTo(index)
            }}
            style={{
              opacity: current === index + 1 ? 1 : 0.2,
              objectFit: 'contain',
              verticalAlign: 'middle',
              height: '80px',
              width: '80px',
            }}
          />
        ))}
      </div>
    </Carousel>
  )
}
